import {Box, styled} from '@mui/material';

export const StyledBoxTitle = styled(Box)`
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin-bottom: 10px;
	align-items: flex-start;
`;
